import { 
  Truck, 
  Phone, 
  Clock, 
  MapPin, 
  Stethoscope,
  FileText,
  Calendar,
  MessageCircle,
  Shield,
  CheckCircle,
  ChevronRight
} from 'lucide-react';

export const ServiciosPage = () => {

  const serviciosDomicilio = [
    {
      icono: <Clock className="w-8 h-8" />,
      titulo: "Entrega Express",
      descripcion: "Recibe tus medicamentos en 30-60 minutos en el área urbana",
      color: "from-blue-500 to-cyan-500"
    },
    {
      icono: <Shield className="w-8 h-8" />,
      titulo: "Cadena de Frío",
      descripcion: "Transportamos medicamentos que requieren refrigeración con equipos especializados",
      color: "from-[#4CAF50] to-[#2196F3]"
    },
    {
      icono: <FileText className="w-8 h-8" />,
      titulo: "Validación de Recetas",
      descripcion: "Verificación digital de recetas médicas por profesionales farmacéuticos",
      color: "from-purple-500 to-pink-500"
    },
    {
      icono: <Truck className="w-8 h-8" />,
      titulo: "Cobertura Extendida",
      descripcion: "Llegamos a toda el área metropolitana con tarifas preferenciales",
      color: "from-orange-500 to-red-500"
    }
  ];

  const serviciosAdicionales = [
    {
      icono: <Stethoscope className="w-6 h-6" />,
      titulo: "Asesoría Farmacéutica",
      descripcion: "Consulta con nuestros químicos farmacéuticos sobre el uso correcto de medicamentos"
    },
    {
      icono: <Phone className="w-6 h-6" />,
      titulo: "Línea WhatsApp",
      descripcion: "Atención por WhatsApp dentro de nuestro horario para emergencias y consultas"
    },
    {
      icono: <Calendar className="w-6 h-6" />,
      titulo: "Recordatorio de Medicamentos",
      descripcion: "Te ayudamos a recordar cuándo debes tomar o reponer tus medicamentos"
    },
    {
      icono: <MessageCircle className="w-6 h-6" />,
      titulo: "Consulta por WhatsApp",
      descripcion: "Escríbenos directamente para una atención más rápida y personalizada"
    }
  ];

  const pasosPedido = [
    {
      paso: "1",
      titulo: "Elige tus productos",
      descripcion: "Navega por nuestro catálogo o usa la búsqueda para encontrar lo que necesitas"
    },
    {
      paso: "2",
      titulo: "Agrega al carrito",
      descripcion: "Selecciona la cantidad y agrega los productos a tu carrito de compras"
    },
    {
      paso: "3",
      titulo: "Confirma tu pedido",
      descripcion: "Ingresa tu dirección de entrega y selecciona tu método de pago preferido"
    },
    {
      paso: "4",
      titulo: "Recibe en casa",
      descripcion: "Te notificaremos cuando tu pedido esté en camino y cuando llegue a tu puerta"
    }
  ];

  return (
    <div className="min-h-screen transition-colors duration-300 bg-gray-50">
      
      {/* Hero */}
      <section className="relative py-20 overflow-hidden bg-gradient-to-br from-[#4CAF50] to-[#2196F3]">
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full blur-2xl"></div>
          <div className="absolute bottom-10 right-10 w-48 h-48 bg-white/10 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative w-full mx-auto px-2 sm:px-3 lg:px-4 text-center">
          <div className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium mb-6 bg-white/20 text-white">
            <Truck className="w-4 h-4 mr-2" />
            Lun-Dom: 8:00 AM - 9:00 PM
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Servicio de Domicilios
          </h1>
          <p className="text-white/90 text-lg md:text-xl max-w-3xl mx-auto">
            Llevamos tu salud hasta la puerta de tu casa. Entrega rápida, segura 
            y confiable con el respaldo de nuestros profesionales farmacéuticos.
          </p>
        </div>
      </section>

      {/* Cobertura y tarifas */}
      <section className="py-16 px-2 sm:px-3 lg:px-4">
        <div className="w-full mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-8 rounded-2xl text-center bg-white shadow-lg">
              <div className="w-16 h-16 bg-[#4CAF50]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="w-8 h-8 text-[#4CAF50]" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-gray-900">Área de Cobertura</h3>
              <p className="text-gray-600">
                Cobertura en toda el área urbana y zonas aledañas hasta 15km de distancia
              </p>
            </div>

            <div className="p-8 rounded-2xl text-center bg-white shadow-lg">
              <div className="w-16 h-16 bg-[#2196F3]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="w-8 h-8 text-[#2196F3]" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-gray-900">Tiempos de Entrega</h3>
              <p className="text-gray-600">
                Entrega express: 30-60 min. Entrega estándar: 2-4 horas
              </p>
            </div>

            <div className="p-8 rounded-2xl text-center bg-white shadow-lg">
              <div className="w-16 h-16 bg-gradient-to-br from-[#4CAF50]/10 to-[#2196F3]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Truck className="w-8 h-8 text-[#2196F3]" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-gray-900">Envío Gratis</h3>
              <p className="text-gray-600">
                En compras superiores a $50.000. Tarifa base: $5.000
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Características del servicio */}
      <section className="py-16 bg-white">
        <div className="w-full mx-auto px-2 sm:px-3 lg:px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            ¿Por qué elegir nuestro domicilio?
          </h2>
          
          <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
            {serviciosDomicilio.map((servicio, index) => (
              <div 
                key={index}
                className="p-6 rounded-2xl text-center transition-all duration-300 hover:scale-[1.02] bg-gray-50"
              >
                <div className={`w-16 h-16 mx-auto mb-4 rounded-xl bg-gradient-to-br ${servicio.color} text-white flex items-center justify-center`}>
                  {servicio.icono}
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-900">
                  {servicio.titulo}
                </h3>
                <p className="text-sm text-gray-600">
                  {servicio.descripcion}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cómo hacer tu pedido */}
      <section className="py-16 px-2 sm:px-3 lg:px-4">
        <div className="w-full mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            ¿Cómo hacer tu pedido?
          </h2>
          
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {pasosPedido.map((paso, index) => (
              <div 
                key={index}
                className="relative p-6 rounded-2xl text-center bg-white shadow-lg"
              >
                <div className="w-12 h-12 bg-gradient-to-r from-[#4CAF50] to-[#2196F3] text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4">
                  {paso.paso}
                </div>
                <h3 className="font-bold mb-2 text-gray-900">
                  {paso.titulo}
                </h3>
                <p className="text-sm text-gray-600">
                  {paso.descripcion}
                </p>
                
                {index < pasosPedido.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2">
                    <ChevronRight className="w-6 h-6 text-[#4CAF50]" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Servicios adicionales */}
      <section className="py-16 bg-gradient-to-br from-[#4CAF50]/5 to-[#2196F3]/5">
        <div className="w-full mx-auto px-2 sm:px-3 lg:px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            Servicios Adicionales
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            {serviciosAdicionales.map((servicio, index) => (
              <div 
                key={index}
                className="flex items-center space-x-4 p-6 rounded-xl bg-white"
              >
                <div className="p-3 bg-[#4CAF50]/10 rounded-lg text-[#4CAF50]">
                  {servicio.icono}
                </div>
                <div>
                  <h3 className="font-bold text-gray-900">
                    {servicio.titulo}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {servicio.descripcion}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-2 sm:px-3 lg:px-4">
        <div className="w-full mx-auto">
          <div className="rounded-3xl p-8 md:p-12 text-center bg-gradient-to-br from-[#4CAF50] to-[#2196F3]">
            <h2 className="text-3xl font-bold text-white mb-4">
              ¿Necesitas un domicilio ahora?
            </h2>
            <p className="text-white/90 mb-8 max-w-2xl mx-auto">
              Puedes hacer tu pedido por WhatsApp. 
              Nuestro equipo está listo para atenderte.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="https://wa.me/573193650538"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 px-8 py-4 bg-green-500 text-white rounded-xl font-bold hover:bg-green-600 transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
                <span>Pedir por WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Preguntas frecuentes */}
      <section className="py-16 bg-white">
        <div className="w-full mx-auto max-w-4xl px-2 sm:px-3 lg:px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            Preguntas Frecuentes
          </h2>
          
          <div className="space-y-4">
            {[
              {
                pregunta: "¿Cuál es el horario de domicilios?",
                respuesta: "Nuestro servicio de domicilios está disponible de lunes a domingo de 8:00 AM a 9:00 PM. Los pedidos fuera de este horario serán atendidos al siguiente día hábil."
              },
              {
                pregunta: "¿Puedo pagar contra entrega?",
                respuesta: "Sí, aceptamos pago contra entrega en efectivo o con datáfono. También puedes pagar en línea con tarjeta de crédito/débito."
              },
              {
                pregunta: "¿Qué pasa si no están todos los productos?",
                respuesta: "Te contactaremos inmediatamente para ofrecerte alternativas o reembolsar el valor de los productos no disponibles."
              },
              {
                pregunta: "¿Entregan medicamentos que requieren refrigeración?",
                respuesta: "Sí, contamos con vehículos equipados con cadena de frío para garantizar la conservación de medicamentos termolábiles."
              }
            ].map((faq, index) => (
              <div 
                key={index}
                className="p-6 rounded-xl bg-gray-50"
              >
                <h3 className="font-bold mb-2 flex items-start text-gray-900">
                  <CheckCircle className="w-5 h-5 text-[#4CAF50] mr-2 flex-shrink-0 mt-0.5" />
                  {faq.pregunta}
                </h3>
                <p className="ml-7 text-gray-600">
                  {faq.respuesta}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiciosPage;
